import { Check, Copy } from "lucide-react";

import { WebhookModalProps } from "./types";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import useCopy from "@/hooks/useCopy";

export const WebhookSecretModal = ({ secretSignature, open, setOpen }: WebhookModalProps) => {
  const { copy, isCopying } = useCopy();

  const handleCopy = () => {
    copy(secretSignature);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Webhook Secret Signature</DialogTitle>
          <DialogDescription>
            Copy and save this secret signature. You will need it to verify webhook requests.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="relative">
            <div className="flex items-center justify-between rounded-md border p-3 shadow-sm">
              <code className="break-all font-mono text-sm">{secretSignature}</code>
              <Button variant="ghost" size="sm" onClick={handleCopy} className="ml-2 h-8 px-2">
                {isCopying ? (
                  <Check className="h-4 w-4 text-green-500" />
                ) : (
                  <Copy className="h-4 w-4" />
                )}
              </Button>
            </div>
          </div>

          <div className="space-y-2">
            <h4 className="text-sm font-medium">How to use this secret:</h4>
            <ul className="list-disc space-y-1 pl-5 text-sm text-muted-foreground">
              <li>Use this secret to verify the signature in the webhook payload</li>
              <li>
                The signature is included in the{" "}
                <code className="text-xs">X-PromptLayer-Signature</code> header
              </li>
              <li>Verify the signature to ensure the webhook request is authentic</li>
            </ul>
          </div>
        </div>
        <div className="flex justify-end">
          <DialogClose>
            <Button>Close</Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};
